import React from 'react';
import { ButtonLink, Text } from '@goodfynd/ui';

import images from '../../../config/images';
import { useMobileSize } from '../../../utils/base';

import {
  StyledBgMobile,
  StyledBgMobileContainer,
  StyledMission,
  StyledPanelContent,
  StyledPanelMission,
} from './styles';

export default function PanelMission() {
  const isMobile = useMobileSize();
  const backgroundImage =
    'url(' +
    (isMobile ? images.bg.careersHeaderMobile : images.bg.careersHeader) +
    ')';
  return (
    <React.Fragment>
      <StyledBgMobileContainer>
        <StyledBgMobile
          css={{
            backgroundImage,
          }}
        />
      </StyledBgMobileContainer>
      <StyledPanelMission
        css={{
          backgroundImage,
        }}
      >
        <StyledPanelContent>
          <StyledMission>
            <Text as="heading3">
              We&apos;re on a mission to help mobile businesses grow.
            </Text>
            <Text as="subhead1">
              We have a healthy obsession with delicious food and the innovative
              chefs that create it. Just like the businesses we serve, our
              technology seeks to meet the needs of our owners and operators
              wherever they may be.
            </Text>

            <ButtonLink
              fullWidth={false}
              href="https://www.indeed.com/cmp/Goodfynd.com/jobs"
              margin="16px 0 0"
              target="_blank"
            >
              View Open Positions
            </ButtonLink>
          </StyledMission>
        </StyledPanelContent>
      </StyledPanelMission>
    </React.Fragment>
  );
}
